<template>
    <div class="login-box" v-if="localShowPage" @click="closePage">
        <div class="login-container" @click.stop="">
            <div class="delete-icon el-icon-close" @click="closePage"></div>
            <div class="login-bg">
                <img
                    src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/loginbg.png"
                    alt=""
                />
            </div>
            <div class="login-card">
                <h2 class="title">{{ $t("headerFoot.login1") }}</h2>
                <div class="input-group input-group1">
                    <div class="phone-prefix">+86</div>
                    <input
                        v-model="loginForm.phone"
                        type="tel"
                        :placeholder="`${$t('login.placeholder')}`"
                        class="phone-input"
                        maxlength="11"
                    />
                </div>
                <div class="input-group input-group2">
                    <input
                        v-model="loginForm.code"
                        type="text"
                        :placeholder="`${$t('login.placeholder1')}`"
                        class="code-input"
                        maxlength="6"
                    />
                    <button
                        type="button"
                        class="get-code-btn"
                        :disabled="counting"
                        @click="clickCode"
                    >
                        {{
                            counting
                                ? currentLocale === "zh-CN" ? `${countdown}s后重新获取` : `Resend in ${countdown}s`
                                : $t("headerFoot.getCode")
                        }}
                    </button>
                </div>
                <!-- @click="checkAgreement" -->
                <div class="footer">
                    <div class="cefr-label">
                        <div class="radio" @click="agreed=!agreed" >
                            <div :class="agreed ? 'active' : ''"></div>
                        </div>
                        <div class="content">
                            <!-- <span v-html="agreementText"></span> -->
                            <span @click="agreed=!agreed" style="user-select: none; ">{{ $t("headerFoot.logintip") }}</span>
                            <div v-if="agreements && agreements.length > 10" style="display: flex">
                                <div
                                    v-for="(agreement, index) in agreements"
                                    :key="agreement.id"
                                    style="display: flex"
                                >
                                    <span
                                        @click="checkAgreement(index)"
                                        class="agreement-btn"
                                    >
                                        《{{
                                            currentLocale === "zh-CN"
                                                ? agreement.name
                                                : agreement.nameEn
                                        }}》
                                    </span>
                                    <span
                                        v-if="index < agreements.length - 1"
                                        class="and"
                                        style="color: #666"
                                    >
                                        {{
                                            currentLocale === "zh-CN" ? "及" : "and"
                                        }}
                                    </span>
                                </div>
                        </div>
                        <div v-else style="display: flex">
                            <p @click="checkAgreement(0)" class="agreement-btn">
                                {{
                                    currentLocale === "zh-CN"
                                        ? "《用户服务协议》"
                                        : "《User Service Agreement》"
                                }}
                            </p>
                            <span class="and" style="color: #666">
                                {{ currentLocale === "zh-CN" ? "及" : "and" }}
                            </span>
                            <p @click="checkAgreement(1)" class="agreement-btn">
                                {{
                                    currentLocale === "zh-CN"
                                        ? "《隐私政策》"
                                        : "《Privacy Policy》"
                                }}
                            </p>
                        </div>
                        </div>
                    </div>
                </div>
                <button
                    type="submit"
                    class="login-btn"
                    v-loading="loading"
                    @click="handleLogin"
                >
                    {{ $t("headerFoot.login") }}
                </button>
                <!-- <div class="footer">
                    <div class="cefr-label">
                        {{ $t("headerFoot.logintip") }}
                        <div class="radio">
                            <div :class="agreed ? 'active' : ''"></div>
                        </div>
                        <div v-if="agreements && agreements.length > 0">
                            <div
                                v-for="(agreement, index) in agreements"
                                :key="agreement.id"
                                style="display: flex"
                            >
                                <p
                                    @click="modalcnt(index)"
                                    class="agreement-btn"
                                >
                                    《{{
                                        currentLocale === "zh-CN"
                                            ? agreement.name
                                            : agreement.nameEn
                                    }}》
                                </p>
                                <div
                                    v-if="index < agreements.length - 1"
                                    class="and"
                                    style="color: #666"
                                >
                                    {{
                                        currentLocale === "zh-CN" ? "及" : "and"
                                    }}
                                </div>
                            </div>
                        </div>
                        <div v-else style="display: flex">
                            <p @click="modalcnt(0)" class="agreement-btn">
                                {{
                                    currentLocale === "zh-CN"
                                        ? "《用户服务协议》"
                                        : "《User Service Agreement》"
                                }}
                            </p>
                            <span class="and" style="color: #666">
                                {{ currentLocale === "zh-CN" ? "及" : "and" }}
                            </span>
                            <p @click="modalcnt(1)" class="agreement-btn">
                                {{
                                    currentLocale === "zh-CN"
                                        ? "《隐私政策》"
                                        : "《Privacy Policy》"
                                }}
                            </p>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <Modal
            :showModal="showModal"
            :show-default-content="false"
            :show-default-tips="false"
            :show-cancel="false"
            :show-submit="false"
            @confirm="showModal = false"
            @cancel="showModal = false"
            :title="currentTitle"
        >
            <!-- 自定义内容插槽 -->
            <template #content>
                <div
                    class="sign_dialog_content"
                    ref="scrollContainer"
                    @scroll="handleScroll"
                >
                    <div v-for="page in pages" :key="page.pageNumber">
                        <pdf
                            :src="pdfDocument"
                            :page="page.pageNumber"
                            @error="onPageError(page.pageNumber, $event)"
                            @progress="onPageProgress(page.pageNumber, $event)"
                            @num-pages="updateTotalPages"
                            class="pdf-page"
                        />
                    </div>
                </div>
            </template>
            <!-- 去掉强制阅读 -->
            <template #footer>
                <div class="dialog_footer">
                    <div
                        class="btn"
                        :class="isRead ? 'active' : ''"
                        @click="handleAgree"
                    >
                    {{ $t("studentInfo.readTwo") }}
                        <!-- {{
                            isRead
                                ? $t("studentInfo.readTwo") +
                                  `(${currentAgreementIndex + 1}/${
                                      agreements.length
                                  })`
                                : $t("studentInfo.readTwo") +
                                  `(${currentAgreementIndex + 1}/${
                                      agreements.length
                                  })`
                        }} -->
                    </div>
                </div>
                <!-- <button class="btn-read" @click="showModal = false">
                    {{ $t("headerFoot.read") }}
                </button> -->
            </template>
        </Modal>
      <el-dialog
        :title="$t('login.pleaseVerification')"
        width="360px"
        center
        :visible.sync="captchaVisible"
        :close-on-click-modal="false"
        @closed="refresh"
        append-to-body
        class="absolute-center-dialog"
      >
        <SliderVerify
                ref="sliderVerify"
                :visible.sync="captchaVisible"
                @success="onSuccess"
                @fail="onFail"
                @again="onAgain"
                :sliderHint="$t('login.dragFillPpuzzle')"
                />
      </el-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import pdf from "vue-pdf";
import { getPhoneCode, getLegalPdf, getCaptchaVerify } from "@/plugins/api";
import SliderVerify from "@/components/SliderVerify.vue";

export default Vue.extend({
    data() {
        return {
            localShowPage: this.showPage, // 使用本地状态副本
            loading: false,
            counting: false,
            countdown: 120,
            loginForm: {
                phone: "",
                code: "",
            },
            userInfo: null,
            currentAgreementIndex: 0,
            showModal: false,
            currentLocale: "zh-CN",
            agreed: false,
            error: null,
            pdfDocument: null,
            pages: [],
            totalPages: 0,
            loadedPages: 0,
            scale: 1,
            pageLoadErrors: [],
            agreements: [],
            currentTitle: "",
            isRead: true,
            captchaVisible: false,
        };
    },
    props: {
        showPage: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        showPage: {
            handler(newVal, oldVal) {
                this.localShowPage = newVal; // 同步 props 到本地状态
                if (newVal) {
                    document.body.style.overflow = "hidden";
                    // this.getLegalList();
                    this.loadAllPages();
                } else {
                    document.body.style.overflow = "unset";
                }
            },
            immediate: true, // 是否在创建时立即执行一次
            deep: false, // 是否需要深度监听（布尔值不需要）
        },
        localShowPage(val) {
            if (!val) {
                document.body.style.overflow = "unset";
                this.$emit("close"); // 通知父组件关闭
            } else {
                // this.getLegalList()
            }
        },
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
                this.updateCurrentTitle();
            },
            immediate: true,
        },
        // 监听当前协议索引变化，更新标题
        currentAgreementIndex() {
            this.updateCurrentTitle();
        },
    },
    created () {
        this.getLegalList();
    },
    mounted() {
        this.loadAllPages();
    },
    computed: {
        agreementText() {
            if (!this.agreements || this.agreements.length === 0) {
                return this.currentLocale === "zh-CN"
                    ? `我已阅读并同意<span style="color: #1890ff;">《服务协议》、《隐私政策》和《考生须知》。</span>`
                    : `I have read and agree to the Terms of <span style="color: #1890ff;"> Service Agreement, Privacy Policy, and Test-taker Instructions.</span>`;
            }

            const isZh = this.currentLocale === "zh-CN";
            const agreementNames = this.agreements.map((item) =>
                isZh ? item.name : item.nameEn
            );

            if (isZh) {
                return `我已阅读并同意<span style="color: #1890ff;">《${agreementNames.join(
                    "》、《"
                )}》。</span>`;
            } else {
                if (agreementNames.length === 1) {
                    return `I have read and agree to the <span style="color: #1890ff;"> ${agreementNames[0]}.</span>`;
                } else if (agreementNames.length === 2) {
                    return `I have read and agree to the <span style="color: #1890ff;"> ${agreementNames[0]} and ${agreementNames[1]}.</span>`;
                } else {
                    const last = agreementNames.pop();
                    return `I have read and agree to the <span style="color: #1890ff;"> ${agreementNames.join(
                        ", "
                    )} and ${last}.</span>`;
                }
            }
        },
        // 添加计算属性获取当前语言的图片数组
        currentAgreementImages() {
            if (!this.agreements[this.currentAgreementIndex]) {
                return [];
            }
            const agreement = this.agreements[this.currentAgreementIndex];
            // 根据当前语言选择对应的图片数组
            return this.currentLocale === "zh-CN"
                ? agreement.imageUrl || []
                : agreement.imageUrlEn || [];
        },
    },
    components: {
        pdf,
        SliderVerify
    },
    methods: {
        checkAgreement(index) {
            // this.isRead = false;
            this.currentAgreementIndex = index
            this.showModal = true;
            this.$nextTick(() => {
                this.loadAllPages();
            });
        },
        async loadAllPages() {
            // this.loading = true;
            this.error = null;
            this.pages = [];
            this.loadedPages = 0;
            this.pageLoadErrors = [];
            this.totalPages = 0;
            // 销毁 PDF 文档
            if (this.pdfDocument) {
                try {
                    if (typeof this.pdfDocument.destroy === "function") {
                        await this.pdfDocument.destroy();
                    }
                } catch (err) {
                    console.error("Error destroying PDF:", err);
                }
                this.pdfDocument = null;
            }
            try {
                if (
                    !this.agreements ||
                    !this.agreements[this.currentAgreementIndex]
                ) {
                    throw new Error("协议不存在");
                }
                // 获取 PDF URL
                const agreement = this.agreements[this.currentAgreementIndex];
                const pdfUrl =
                    this.currentLocale === "zh-CN"
                        ? agreement.pdfUrl
                        : agreement.pdfUrlEn;

                if (!pdfUrl) {
                    throw new Error("PDF URL 不存在");
                }
                const loadingTask = await pdf.createLoadingTask({
                    url: pdfUrl,
                    withCredentials: false,
                    // 关键配置：字体渲染选项
                    // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/cmaps/',
                    // cMapPacked: true,
                    // // 标准字体配置
                    // standardFontDataUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/standard_fonts/',
                    // 渲染选项
                    renderInteractiveForms: true,
                    enableXfa: false, // 禁用 XFA 可能有助于解决标点问题
                    // 字体配置
                    useSystemFonts: false,
                    fontExtraProperties: true,
                    // 禁用某些可能导致问题的特性
                    disableFontFace: false,
                    disableRange: true,
                    disableStream: true,
                    disableAutoFetch: true,
                    pdfBug: false,
                });

                this.pdfDocument = loadingTask;
                const doc = await this.pdfDocument.promise;
                this.totalPages = doc.numPages;
                // 创建页面数组
                for (let i = 1; i <= this.totalPages; i++) {
                    this.pages.push({
                        pageNumber: i,
                        loaded: false,
                        error: null,
                        canvasReady: false,
                        retryCount: 0,
                    });
                }
                // 监听所有页面加载完成
                await this.waitForAllPages();
            } catch (err) {
                // this.error = `文档加载失败: ${err.message || '未知错误'}`
                // this.loading = false;
            }
        },
        waitForAllPages() {
            // 检查所有页面是否加载完成
            const checkInterval = setInterval(() => {
                if (
                    this.loadedPages + this.pageLoadErrors.length >=
                    this.totalPages
                ) {
                    clearInterval(checkInterval);
                    this.loading = false;
                    if (this.pageLoadErrors.length > 0) {
                        // this.error = `${this.pageLoadErrors.length}个页面加载失败`
                    }
                }
            }, 100);
        },

        onPageProgress(pageNumber, progress) {
            // 页面加载进度
            // console.log(`页面 ${pageNumber} 加载进度:`, progress);
        },

        onPageError(pageNumber, error) {
            // console.error(`页面 ${pageNumber} 加载失败:`, error)
            this.pageLoadErrors.push({ pageNumber, error });
            // 更新页面状态
            const page = this.pages.find((p) => p.pageNumber === pageNumber);
            if (page) {
                page.error = error;
            }
        },
        updateTotalPages(pageCount) {
            // 确保总页数正确
            if (pageCount && pageCount > this.totalPages) {
                this.totalPages = pageCount;
            }
        },
        handleScroll(e) {
            const element = this.$refs.scrollContainer;
            const { scrollTop, clientHeight, scrollHeight } = element;
            // 判断是否接近底部（可根据需要调整阈值）
            const threshold = 50; // 距离底部50px时触发
            const isNearBottom =
                scrollTop + clientHeight >= scrollHeight - threshold;
            if (isNearBottom) {
                // this.isRead = true;
            }
        },
        closePage() {
            this.localShowPage = false;
            this.$emit("closeLogin", false);
        },
        // 处理协议同意
        handleAgree() {
            this.showModal = false;
            return
            if (this.isRead) {
                if (this.currentAgreementIndex < this.agreements.length - 1) {
                    // 如果不是最后一个协议，切换到下一个
                    this.currentAgreementIndex++;
                    this.updateCurrentTitle();
                    // 重置滚动位置
                    setTimeout(() => {
                        this.$refs.scrollContainer.scrollTop = 0;
                        // this.isRead = false;
                        // this.agreed = false;
                    }, 100);
                    this.$nextTick(() => {
                        this.loadAllPages();
                    });
                } else {
                    // 如果是最后一个协议，关闭弹窗并设置同意状态
                    this.showModal = false;
                    // this.isRead = true;
                    // this.agreed = true;
                }
            } else {
                let title =
                    this.$i18n.locale === "zh-CN"
                        ? "请阅读完整协议内容"
                        : "Please read the complete agreement content";
                this.$message.warning(title);
                this.agreed = false;
            }
        },
        goTop() {
            this.$nextTick(() => {
                const element = this.$refs.scrollContainer;
                if (!element) return;
                element.scrollTop = 0;
            });
        },
        clickCode() {
            if (!this.loginForm.phone || this.loginForm.phone.length !== 11) {
                this.$message({ message: this.$t('login.pleaseEnterPhone'), type: "warning" });
                return;
            }
            this.captchaVisible = true
        },
        getCode() {
            this.counting = true;
            // getPhoneCode({ phone: this.loginForm.phone }).then(() => {
            //     const timer = setInterval(() => {
            //         this.countdown--;
            //         if (this.countdown === 0) {
            //             clearInterval(timer);
            //             this.counting = false;
            //             this.countdown = 60;
            //         }
            //     }, 1000);
            // });
             const timer = setInterval(() => {
                this.countdown--;
                if (this.countdown === 0) {
                    clearInterval(timer);
                    this.counting = false;
                    this.countdown = 120;
                }
            }, 1000);
        },
        handleLogin() {
            if (!this.agreed) {
                this.$message({
                    message:
                        this.$i18n.locale === "zh-CN"
                            ? "请先阅读并同意协议"
                            : "Please read and agree to the agreement first",
                    type: "warning",
                });
                return;
            }
            if (!this.loginForm.phone || !this.loginForm.code) {
                this.$message({ message: this.$t('login.pleaseEnterCode'), type: "warning" });
                return;
            }
            this.loading = true;
            try {
                const loading = this.$loading({
                    lock: true,
                    text: "Loading",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$store
                    .dispatch("auth/login", {
                        phone: this.loginForm.phone,
                        code: this.loginForm.code,
                    })
                    .then((res) => {
                        this.$store.dispatch("auth/getUserInfo");
                        this.localShowPage = false;
                        this.$emit("closeLogin", false);
                    })
                    .catch((error) => {
                        console.log(error, "+++");
                    });
                loading.close();
            } catch (error) {
                this.$message({
                    message: "登录失败",
                    type: "error",
                });
            } finally {
                this.loading = false;
            }
        },
        // 获取法律文件
        async getLegalList() {
            try {
                const res = await getLegalPdf({
                    type: "1", //2：报名协议；1:登录注册协议
                });
                if (res.rows) {
                    this.agreements = res.rows;
                    this.updateCurrentTitle();
                } else {
                    this.agreements = [];
                }
            } catch (error) {
                this.agreements = [];
            }
        },
        // 更新当前协议标题
        updateCurrentTitle() {
            if (
                this.agreements &&
                this.agreements[this.currentAgreementIndex]
            ) {
                this.currentTitle =
                    this.currentLocale === "zh-CN"
                        ? this.agreements[this.currentAgreementIndex].name
                        : this.agreements[this.currentAgreementIndex].nameEn;
            }
        },
        modalcnt(index) {
            // 如果没有协议数据，显示默认内容
            if (!this.agreements || this.agreements.length === 0) {
                return;
            }

            // 检查索引是否有效
            if (index < 0 || index >= this.agreements.length) {
                this.$message({
                    message:
                        this.currentLocale === "zh-CN"
                            ? "该协议不存在"
                            : "Agreement not found",
                    type: "info",
                });
                return;
            }

            this.updateCurrentTitle(index);

            this.currentAgreementIndex = index;

            if (!this.agreements[this.currentAgreementIndex]) {
                return [];
            }
            const agreement = this.agreements[this.currentAgreementIndex];
            // 根据当前语言选择对应的图片数组
            this.currentAgreementImages =
                this.currentLocale === "zh-CN"
                    ? agreement.imageUrl || []
                    : agreement.imageUrlEn || [];
            this.showModal = true;
        },
         refresh () {
            this.$refs.sliderVerify.refresh();
         },
         async onSuccess (captcha) {
            const obj = {
                key: captcha.nonceStr,
                distance: captcha.value,
                phone: this.loginForm.phone,
            };
             try {
               const res =  await getCaptchaVerify(obj)
                this.$message({
                    message: "success!",
                    type: "success",
                });
                this.onFail()
                this.captchaVisible = false;
                this.getCode()
             } catch (error) {
                this.onFail()
            }
         },
         onFail () {
            this.$refs.sliderVerify.refresh();
         },
         onAgain () {
            this.$message({
                message: "滑动操作异常，请重试",
                type: "error",
            });
            this.$refs.sliderVerify.refresh();
         }
    },
    beforeDestroy() {},
});
</script>
<style lang="stylus" scoped>

// 动画效果
@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.login-box {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: slideIn 0.3s ease;
}

.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    // min-height: 100vh;
    .login-bg {
        border-radius: 20px;
        width: 90%;
        max-width: 380px;
        margin-right: -10px;
        height: 400px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .login-card {
        height: 400px;
        background: white;
        padding: 20px 20px;
        border-radius: 20px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        width: 90%;
        // max-width: 400px;
        box-sizing: border-box;
        position: relative;
    }

    .title {
        text-align: center;
        margin-bottom: 30px;
        color: #333;
        font-size: 22px;
    }

    .input-group {
        display: flex;
        margin-bottom: 20px;
        // border: 1px solid #ddd;
        border-radius: 8px;
        overflow: hidden;
        transition: border-color 0.3s;

        .phone-prefix {
            display: flex;
            align-items: center;
            padding: 0 15px;
            // background: #f8f9fa;
            color: #666;
            font-weight: 500;
            // border: 1px solid #ddd;
            position: relative;
        }

        .phone-prefix::after {
            content: '';
            top: 10px;
            right: 0px;
            width: 1px;
            height: 26px;
            background: #ddd;
            position: absolute;
            z-index: 1;
        }

        .phone-input, .code-input {
            flex: 1;
            padding: 15px;
            border: none;
            outline: none;
            font-size: 16px;
        }

        .code-input {
            border: 1px solid #ddd;
            border-radius: 10px;
        }
    }

    .input-group1 {
        border: 1px solid #ddd;
    }

    .input-group:focus-within {
        border-color: #007bff;
    }

    .input-group2 {
        justify-content: space-between;
    }

    .get-code-btn {
        padding: 0 20px;
        background: #fff;
        color: #0043E0;
        cursor: pointer;
        font-size: 14px;
        white-space: nowrap;
        transition: background 0.3s;
        border: 1px solid #ddd;
        border-radius: 10px;
        margin-left: 10px;
    }

    .get-code-btn:hover:not(:disabled) {
        // background: #0056b3;
    }

    .get-code-btn:disabled {
        // background: #ccc;
        cursor: not-allowed;
    }

    .login-btn {
        width: 100%;
        padding: 12px;
        background: #0043E0;
        color: white;
        border: none;
        border-radius: 10px;
        font-size: 16px;
        cursor: pointer;
    }

    .login-btn:hover {
        background: #218838;
    }

    .footer {
        width: 100%;
        padding: 10px 0;
        text-align: center;
        // background: #F5F5F5;
        // border-radius: 0px 0px 20px 20px;
        // position: absolute;
        // z-index: 1;
        // bottom: 0;
        // left: 0;
        margin: 50px 0 8px 0;
        cursor: pointer;

    }

    .cefr-label {
        color: #666;
        font-weight: 500;
        display: flex;
        flex-flow: row;
        align-items: center;
        // justify-content: center;
        >div {
            display: flex;
            flex-flow: row;
            // align-items: center;
            // justify-content: center;
        }

        .agreement-btn {
            background: none;
            border: none;
            color: #0043e0;
        }

        .radio {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #999;
            display: flex;
            flex-flow: row;
            justify-content: center;
            align-items: center;

            .active {
                width: 8px;
                height: 8px;
                background-color: #999;
                border-radius: 50%;
            }
            margin-right: 4px;
        }

        .content {
            font-size: 14px;
            color: #999;
            flex: 1;
            flex-wrap: wrap;
            text-align: left;
        }
    }

    .delete-icon {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 2;
        color: #000;
        font-size: 1.6em;
    }
}

.pdf-page {
    display: block;
    max-width: 100%;
    height: auto;
}

.sign_dialog_content {
    max-height: 460px;
    overflow-y: auto;
    // background-color: #f5f7fa;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.6;
    color: #606266;
    height: 400px;

    .sign_checkbox {
        margin-top: 20px;

        ::v-deep .el-checkbox__label {
            font-size: 14px;
        }
    }
}


.absolute-center-dialog {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    ::v-deep .el-dialog__title {
        color: #303133;
        font-size: 20px;
    }
    ::v-deep .el-dialog__close {
        font-size: 26px;
        color: #000;
    }
    ::v-deep .el-dialog--center {
        border-radius: 20px;s
    }
    ::v-deep .el-dialog--center .el-dialog__body {
        padding: 20px;
    }
}

.dialog_footer {
    text-align: center;
    width: 100%;
    .btn {
        padding: 12px 20px;
        border-radius: 30px;
        text-align: center;
        background: #ddd;
        color: #666;
        transition: all 0.3s;
    }

    .btn.active {
        background: #ff3054;
        color: white;
    }
}

.refund-modal-footer .btn-read {
    width: 100% !important;
    background: red;
    color: #fff;
    border: none;
}

/* 手机类 */
@media (max-width: 640px) {
    .login-container {
        .login-bg {
            display: none;
        }

        .phone-prefix {
            font-size: 3vw;
        }

        .input-group {
            .phone-input, .code-input {
                font-size: 3.2vw;
                padding: 3vw;
            }
        }

        .get-code-btn {
            font-size: 3vw;
        }

        .title {
            font-size: 4.6vw;
        }

        .login-card {
            width: 100%;
            height: 88vw;
            // padding: 4vw 2vw;
            max-width: 90vw;
        }

        .footer {
            padding: 2vw 0;
            margin: 14vw 0 0vw 0;

            // line-height: 12vw;
            .cefr-label {
                font-size: 2.8vw;
                .radio {
                    width: 4vw;
                    height: 4vw;
                    margin-right: 1.2vw;
                }
                .radio.active {
                    width: 2vw;
                    height: 2vw;
                }
                .content {
                    font-size: 2.8vw;
                }
            }
        }
    }
    .login-container .login-btn {
        font-size: 3.6vw;
        padding: 2.8vw;
    }
    .sign_dialog_content {
        max-height: 46vh;
        height: 46vh;
    }
    .absolute-center-dialog {
        ::v-deep .el-dialog__title {
            font-size: 4.6vw;
        }
        ::v-deep .el-dialog__close {
            font-size: 5.8vw;
        }
        ::v-deep .el-dialog--center {
            border-radius: 20px;
        }
        ::v-deep .el-dialog--center .el-dialog__body {
            padding: 20px;
        }
    }
}
</style>